import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import FormToolbar from '../../../components/form/FormToolbar';

const SITE_MANAGEMENT_TAB_SUFFIX = '/1';

const AccountEditToolbar = ({ isDeletable, ...props }) => {
  const location = useLocation();

  if (location.pathname.endsWith(SITE_MANAGEMENT_TAB_SUFFIX)) {
    return null;
  }

  return <FormToolbar {...props} isDeletable={isDeletable} />;
};

AccountEditToolbar.propTypes = {
  isDeletable: PropTypes.bool,
};

AccountEditToolbar.defaultProps = {
  isDeletable: false,
};

export default AccountEditToolbar;
